import * as React from 'react'
import CircleArrow from 'src/assets/images/CircleArrow.svg'

export const CircleArrowIcon = ({ }) => (
    <>
        <img src={CircleArrow} alt="" style={{
            color: 'blue', width: '8rem'
        }} />
    </>
)